import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.css';

export default class KeyValueList extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        rows: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({
                key: PropTypes.string,
                value: PropTypes.string,
                label: PropTypes.string,
                format: PropTypes.func,
            }),
        ])).isRequired,
        column: PropTypes.bool,
    };

    getValue(row) {
        if (row.value !== undefined) return row.value;

        const keyPath = row.key.split('.');
        let value = this.props.data;
        while (keyPath.length) {
            value = value[keyPath.shift()];
        }
        return value;
    }

    getFormattedValue(row) {
        const value = this.getValue(row);
        return row.format ? row.format(value) : value;
    }

    getRows() {
        return this.props.rows.filter(row => {
            if (!row) return false;
            const value = this.getValue(row);
            return value !== undefined && value !== '';
        });
    }

    render() {
        return (
            <div className={classNames(styles.root, {[styles.column]: this.props.column})}>
                {this.getRows().map(row => (
                    <div
                        className={classNames(this.props.column ? [styles.column] : [styles.row])}
                        key={row.key + row.label}>
                        <p className={classNames(this.props.column ? [styles.columnLabel] : [styles.rowLabel])}>
                            {row.label}
                        </p>
                        <p className={classNames(this.props.column ? [styles.columnValue] : [styles.rowValue])}>
                            {this.getFormattedValue(row)}
                        </p>
                    </div>
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/key-value-list/index.js